import * as Yup from 'yup';

export const specialistStepSchema = Yup.object({
    specialists: Yup.array()
        .of(Yup.object({
            id: Yup.string().required('ID specjalisty jest wymagane'),
            fullName: Yup.string().required('Nazwa specjalisty jest wymagana')
        }))
        // Specjaliści są opcjonalni – artykuł może nie mieć przypisanego specjalisty
        .default([]),
});
